import React, { HTMLAttributes, OptionHTMLAttributes, AnchorHTMLAttributes } from "react";
import { IconTypes } from "global/react/constants/icons";
import { CustomFormFieldState } from "../components/FormControls/CustomFormField/CustomFormField";
export interface OrganismHeatingFormProps {
	/** The URL of where to submit the final form payload */
	formSubmitUrl: string;
	/** All step data for the app */
	steps: FormStep[];
	/** A list of key/value translations */
	translations: Record<string, string>;
	endScreen: {
		headline: {
			text: string;
		};
		text: string;
		button: {
			href: AnchorHTMLAttributes<HTMLAnchorElement>['href'];
			text: string;
			title: AnchorHTMLAttributes<HTMLAnchorElement>['title'];
			target: AnchorHTMLAttributes<HTMLAnchorElement>['target']
		} | null;
	}
}


/** The list of CRUD endpoints for the feature */
export type HeatingFormEndpoints = 'submitForm' | 'validateMainEnquiry' | 'validateProductCategory' | 'validateCustomerAddress' | 'validateAdditionalInformation' | 'validateFileAttachments' | 'validateFormSummary';


/** A list of the unique step templates which appear on the whole process */
export type StepTemplate = 'MAIN_ENQUIRY' | 'PRODUCT_CATEGORY' | 'CUSTOMER_ADDRESS' | 'ADDITIONAL_INFORMATION' | 'FILE_ATTACHMENTS' | 'FORM_SUMMARY';

export type CustomFieldFieldTypes = 'text' | 'textarea' | 'email' | 'checkbox' | 'select' | 'file'
interface CustomFieldBase {
	responsiveWidth?: {
		/** Required, like 1-1 for full width, or 1-2 for 50% etc. Layout method for mobile (and desktop if desktop not provided) */
		default: InputWidth;
		/** Optional, like 1-1 for full width, or 1-2 for 50% etc. If given, the responsive layout when on larger screens */
		desktop?: InputWidth;
	};
	/** Custom react components to support these types of fields */
	fieldType: CustomFieldFieldTypes;
	/** The name of a related form field, from which to copy its value (see Address step for copying values between the 3 forms) */
	relatedField?: string;
	/** If true, this field will not appear on the form summary page on the final step */
	excludeFromSummary?: boolean;
	fieldData?: any;
}

type InputWidth = '1-1' | '1-2' | '1-4' | '3-4' | '1-3' | '2-3' | 'expand';
export interface CustomInputType extends React.InputHTMLAttributes<HTMLInputElement>, CustomFieldBase {

}
export interface CustomTextareaType extends React.TextareaHTMLAttributes<HTMLTextAreaElement>, CustomFieldBase {
	/** The name from a related field (for auto-populating from external form) */
	relatedField?: string;
	minRows?: number;
	maxRows?: number;
}

export interface CustomSelectTypeOptions {
	/** The value passed to the backend */
	value: OptionHTMLAttributes<HTMLOptionElement>['value'],
	/** The text in the <option> or the group label */
	label: string,
	/** Sets the option selected by default */
	isSelected?: boolean;

	/** For select option grouping, the related group parent name */
	groupParent?: string;

	/** If provided, a list of additional controls on this step which should become {required=true} */
	requiredAdditionalControls?: string[];

	options?: CustomSelectTypeOptions[];
}
export interface CustomSelectType extends React.SelectHTMLAttributes<HTMLSelectElement>, CustomFieldBase {
	// options?: {
	// 	/** The value passed to the backend */
	// 	value: OptionHTMLAttributes<HTMLOptionElement>['value'],
	// 	/** The text in the <option> */
	// 	label: string,
	// 	/** Sets the option selected by default */
	// 	isSelected?: boolean;

	// 	/** For select option grouping, the related group name */
	// 	groupParent?: string;
	// }[];
	// optionsGroup?: {
	// 	/** The unique name. Must be only [a-ZA-Z0-9-_], like 'group1' or 'group-1 */
	// 	name: string;
	// 	/** The group label */
	// 	label: string;
	// 	/** Select options belonging to the group */
	// 	options: CustomSelectType['options'],
	// }[];
	// options: Omit<CustomSelectTypeOptions, 'foo'>[];
	options: CustomSelectTypeOptions[];
	optionsGroup: CustomSelectTypeOptions[];
}

// export interface CustomSelectOptions extends React.InputHTMLAttributes<HTMLInputElement>, CustomFieldBase {

// 	options?: {
// 		/** The value passed to the backend */
// 		value: OptionHTMLAttributes<HTMLOptionElement>['value'],
// 		/** The text in the <option> */
// 		label: string,
// 		/** Sets the option selected by default */
// 		isSelected?: boolean;

// 		/** For select option grouping, the related group name */
// 		groupParent?: string;
// 	}[];
// 	optionsGroup?: {
// 		/** The unique name. Must be only [a-ZA-Z0-9-_], like 'group1' or 'group-1 */
// 		name: string;
// 		/** The group label */
// 		label: string;
// 		/** Select options belonging to the group */
// 		options: CustomSelectOptions['options'],
// 	};
// }

/** A combined type for all the different types of form control/field */
// export type FormControlType = | CustomTextareaType | CustomInputType | CustomSelectType | CustomSelectOptions;
export type FormControlType = CustomTextareaType | CustomInputType | CustomSelectType;

export type FileUploadData = {
	// title: 'File input',
	// name: 'files[]',
	// id: 'files1',
	// placeholder: 'Select a file...',
	// required: false,
	// fieldType: 'file',
	// value: '',
	// responsiveWidth: {
	// 	default: '1-1',
	// 	desktop: '1-1',
	// },
	// fieldData: {
	// }

	// max number of files which can be uploaded
	maxFileSlots: number;
	// a list of mime types accepted
	allowedContentTypes: string[]; // ['image/jpeg', 'image/webp', 'image/png'];
	// max file size per file, in bytes = (1024 * 1024 * 4) = 4MB
	maxFileSize: number;

	requiresAtLeastOneFile: boolean,

}

export interface FormStep<TFieldNames = string> {
	/** A unique name for the step, like step-1 */
	stepName: string;
	/** Optional title heading for the step */
	stepTitle: string;
	stepInfo: {
		copy: string;
		helpButton: {
			title: string;
			icon: string;
		} | undefined;
	};
	/** The react template to use for the step */
	stepTemplate: StepTemplate;
	/** Support for ordering of the step to be different from the logical order in the array. The order in which the steps appear in the stepper - Lower number = first */
	stepOrder: number;
	/** Modelled step data, which the template will use */
	stepData: {
		fields: Record<TFieldNames extends string ? TFieldNames : string, FormControlType[]>;
		validation: {
			url: string;
		}
		/** A list of translations. The key names correspond to the field key names above. Used on the summary page */
		fieldTranslations: Record<string, string>;
		fileUploadData?: FileUploadData,
	};
}

/** All form steps should use these common props */
export interface FormStepProps {
	data: FormStep;
	onStepControlsChange?: (formData: FormStepInternalState['fields'], stepTemplate: FormStep['stepTemplate']) => void
}

export interface FormSummary<T = FormStepInternalState['fields']> {
	steps: Record<Uppercase<StepTemplate>, T>;
	initialized: Record<Uppercase<StepTemplate>, boolean>;
	/** The state of the validation from the frontend HTML5 validation */
	validatedStepsHTML5: Record<
		Uppercase<StepTemplate>,
		boolean // whether or not the step is valid according to frontend validation
	>;
	validationErrors: Record<
		Uppercase<StepTemplate>,
		Record<string, string>// object with field name and error
	>;
	/** The state of the validation from the backend */
	validatedSteps: Record<
		Uppercase<StepTemplate>,
		boolean // whether or not the step is valid according to backend
	>;
}

export interface FormStepInternalState<TFieldNames = string> {
	fields: Record<TFieldNames extends string ? TFieldNames : string, CustomFormFieldState | undefined>;
}

export type StepsState = Pick<OrganismHeatingFormProps, 'steps' | 'endScreen' | 'formSubmitUrl'> & {
	/** Master switch. If true, the thankyou page will show, else the form steps will show */
	formIsSubmitted: boolean;
	/** Backend can populate this so frontend can show simple submit validation errors */
	formSubmitError: string;
	/** The zero-indexed step number that the user wants to go to (relies on passing validation) */
	requestedStepIndex: number;
	/** The zero-indexed active step that we are on */
	activeStepIndex: number;
	/** A payload holder for the final form state for all steps */
	formSummary: FormSummary;
}

/** Props interface for customised inputs, selects and checkboxes */
export interface CustomFormControlProps {
	field: CustomFormFieldState;
	fullWidth?: boolean;
	// onChange?: (event: React.ChangeEvent<HTMLInputElement>) => any;
	onChange: (event: CustomFormFieldState) => void;
	validationError: string;
	/** @todo... https://mui.com/components/selects/#grouping */
	useNativeControl?: boolean;
}

export enum AccordionArrayAction{
	OpenClose='OPEN_CLOSE',
	Remove='REMOVE',
	Add = 'ADD'
}
